import { Box, Spinner, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export default function LoadingFallback(): JSX.Element {
  const { t } = useTranslation();
  return (
    <Box 
      position="fixed" 
      top="0" 
      left="0" 
      right="0" 
      bottom="0" 
      display="flex" 
      alignItems="center" 
      justifyContent="center"
      bg="white"
      zIndex="9999"
    >
      <VStack spacing={4}>
        <Spinner size="xl" color="blue.500" thickness="4px" speed="0.65s" />
        <Text color="gray.600" fontSize="sm">{t('common.loading')}</Text>
      </VStack>
    </Box>
  );
}

